import ApiServices from '@/services/api'

const DASHBOARD_STATS = ({ commit }) => {
  return ApiServices.dashboardStats()
    .then(response => {
      commit('updateDashboardStats', response)
      return response
    })
}

export default {
  DASHBOARD_STATS
}



// WEBPACK FOOTER //
// ./src/store/modules/superAdminDashboard/actions.js